/**
 * Fushat dinamike të template-ave të kontratave.
 *
 * Një listë e vetme për Krijo/Edito dhe për importin nga Word: më parë ishte
 * kopjuar dy herë brenda faqeve, dhe çdo fushë e re duhej shtuar në dy vende.
 * Çelësat duhet të përputhen me `workerTags` / `COMPANY_TAGS` te ContractList,
 * aty ku zëvendësohen gjatë gjenerimit të kontratës.
 */
export const CONTRACT_TEMPLATE_TAGS = [
  { key: 'FirstName', label: 'Emri' },
  { key: 'LastName', label: 'Mbiemri' },
  { key: 'ParentName', label: 'Emri i prindit' },
  { key: 'PersonalId', label: 'Numri personal/Pasaporta' },
  { key: 'Address', label: 'Adresa' },
  { key: 'Phone', label: 'Telefoni' },
  { key: 'PostalCode', label: 'Kodi postar' },
  { key: 'BankAccount', label: 'Xhirollogaria' },
  { key: 'BankName', label: 'Emri i bankës' },
  { key: 'Birthday', label: 'Datëlindja' },
  { key: 'Country', label: 'Shteti' },
  { key: 'Place', label: 'Qyteti' },
  { key: 'Email', label: 'Email' },
  { key: 'Gender', label: 'Gjinia' },
  { key: 'MaritalStatus', label: 'Statusi martesor' },
  { key: 'Qualification', label: 'Kualifikimi' },
  { key: 'Profession', label: 'Profesioni' },
  { key: 'Position', label: 'Pozita' },
  { key: 'ContractType', label: 'Lloji i kontratës' },
  { key: 'StartDate', label: 'Data e fillimit' },
  { key: 'EndDate', label: 'Data e mbarimit' },
  { key: 'SigningDate', label: 'Data e nënshkrimit' },
  { key: 'ContractNumber', label: 'Nr. i protokollit' },
  { key: 'WorkType', label: 'Lloji i punës' },
  { key: 'SalaryType', label: 'Tipi i pagës' },
  { key: 'Department', label: 'Departamenti' },
  { key: 'BaseSalary', label: 'Paga bazë' },
  { key: 'BrutoNeto', label: 'Bruto/Neto' },
  { key: 'HourSalary', label: 'Paga për orë' },
  { key: 'HourSalaryWeekend', label: 'Paga për orë (fundjavë)' },
  { key: 'HourSalaryHoliday', label: 'Paga për orë (festa)' },
  { key: 'TermsOfContract', label: 'Kushtet e kontratës' },
  { key: 'CompanyName', label: 'Kompania – Emri' },
  { key: 'CompanyNUI', label: 'Kompania – NUI' },
  { key: 'CompanyFiscalNumber', label: 'Kompania – Nr. fiskal' },
  { key: 'CompanyAddress', label: 'Kompania – Adresa' },
  { key: 'CompanyCity', label: 'Kompania – Qyteti' },
  { key: 'CompanyCountry', label: 'Kompania – Shteti' },
  { key: 'CompanyPhone', label: 'Kompania – Telefoni' },
  { key: 'CompanyEmail', label: 'Kompania – Email' },
  { key: 'CompanyWebsite', label: 'Kompania – Web' },
  { key: 'CompanyBankName', label: 'Kompania – Banka' },
  { key: 'CompanyBankAccount', label: 'Kompania – Xhirollogaria' },
  { key: 'CompanyDirector', label: 'Kompania – Përfaqësuesi' },
  { key: 'CompanyLogo', label: 'Kompania – Logo' },
];
